import { render, staticRenderFns } from "./Select2Multiple.vue?vue&type=template&id=17889e47"
import script from "./Select2Multiple.vue?vue&type=script&lang=js"
export * from "./Select2Multiple.vue?vue&type=script&lang=js"
import style0 from "./Select2Multiple.vue?vue&type=style&index=0&id=17889e47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports